module.exports = __webpack_public_path__ + "static/media/comment-exclamation.68c259da.svg";